var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.disabled ? 'cursor-not-allowed' : null]},[(_vm.loaded)?_c('froala',{attrs:{"tag":'textarea',"config":_vm.config,"value":_vm.content},on:{"input":_vm.onInput}}):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }